import * as React from 'react';
import { CloseButton, ButtonTertiary, ButtonPrimary } from 'ui';
import style from './copy-options.scss';
import { RadioSymbol } from 'ui/common';

export const DefaultCopyOptions = ({translate, handleCancel, handleContinue}) => {
  const [count, setCount] = React.useState(1);
  const onChange = e => {        
    setCount( e.target.value );    
  };
  const onContinue = e => handleContinue(e,count);
  return (  
    <div className={`modal ${style.contextMenuModal}`}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5>{translate.copy}</h5>
            <CloseButton data-dismiss="modal" onClick={handleCancel} />
          </div>
          <div className={'modal-body'}>
          <div className={`form-check ${style.grayShadow}`}>           
            <input type="radio" checked={true} className="form-check-input visuallyhidden" id="option-copy"/>
            <label htmlFor="option-copy">
              <RadioSymbol/> {translate.make} <input 
                                  type="number"                                   
                                  id="copyCount" 
                                  step="1" 
                                  min="1" 
                                  max="99" 
                                  value={count} 
                                  onChange={onChange}/> {translate.copies}</label>
          </div>
          </div>            
          <div className={'modal-footer'}>
            <ButtonTertiary dataDismiss="modal" onClick={handleCancel}>
              {translate.cancel}
            </ButtonTertiary>
            <ButtonPrimary onClick={onContinue}>
              {translate.createCopies}
            </ButtonPrimary>
          </div>
        </div>
      </div>
      <div className="modal-background"/>
    </div>);
};
